module.exports = __webpack_public_path__ + "static/families.ff9ee1fa.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/families.jpg
// module id = 548
// module chunks = 0